import { Zap, Globe, Users, Clock, Award, Star, Sparkles } from "lucide-react";


const benefits = [
  "Specialized SAP Recruiters",
  "Extensive Talent Network",
  "Fast Turnaround",
  "Global Reach",
  "Flexible Engagement Models",
  "Dedicated Account Management",
];

export function WhyKapilTech() {
  return (
    <section
      className="w-full py-20 md:py-24 lg:py-16"
      style={{ backgroundColor: "#001534" }}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          {/* Left Content */}
          <div className="flex flex-col gap-6">

            {/* Heading */}
            <h2
              className="text-4xl md:text-5xl font-semibold leading-tight m-0"
              style={{ fontFamily: '"Outfit", sans-serif', color: "#ffffff", lineHeight:"1.3" }}
            >
              Why Businesses Choose{" "} <br/>
                Kapil Tech
            </h2>

            {/* Description with Accent Bar */}
            <div className="flex gap-3">
              <div className="w-1 h-auto rounded-full" style={{ backgroundColor: "#E4002B" }}></div>
              <p
                className="text-lg md:text-xl leading-relaxed m-0"
                style={{ fontFamily: '"Open Sans", sans-serif', color: "#D9E4F2", hyphens:'none', textAlign: "left" }}
              >
                Kapil Tech connects businesses with pre-vetted SAP consultants,
                ERP specialists, AI engineers, cloud experts, and technology
                professionals through flexible staffing and recruitment solutions.
              </p>
            </div>

            {/* Benefits Grid */}
            <div className="grid sm:grid-cols-2 gap-3">
              {benefits.map((item, idx) => {
                const icons = [Zap, Globe, Users, Clock, Star, Award];
                const Icon = icons[idx % icons.length];
                const colors = ["#66C7FF", "#2DD4BF", "#F87171", "#FBBF24", "#A78BFA", "#60A5FA"];
                const lightBgs = [
                  "rgba(102, 199, 255, 0.14)",
                  "rgba(45, 212, 191, 0.14)",
                  "rgba(248, 113, 113, 0.14)",
                  "rgba(251, 191, 36, 0.14)",
                  "rgba(167, 139, 250, 0.14)",
                  "rgba(96, 165, 250, 0.14)",
                ];
                return (
                  <div
                    key={item}
                    className="flex items-center gap-3 rounded-lg p-3 transition-all duration-300 group cursor-default hover:-translate-y-1"
                    style={{ 
                      backgroundColor: "rgba(255, 255, 255, 0.08)",
                      border: "1px solid rgba(255, 255, 255, 0.14)",
                    }}
                  >
                    <div 
                      className="w-8 h-8 rounded-lg flex items-center justify-center transition-all duration-300 group-hover:scale-110"
                      style={{ backgroundColor: "rgba(102, 199, 255, 0.14)" }}
                    >
                      <Icon className="w-4 h-4" style={{ color: '#ffffff' }} />
                    </div>
                    <span
                      className="text-sm font-medium"
                      style={{ color: "#F8FAFC" }}
                    >
                      {item}
                    </span>
                  </div>
                );
              })}
            </div>

            {/* Stats Row */}
            <div className="grid grid-cols-2 gap-3">
              <div
                className="p-4 rounded-lg transition-all duration-300 hover:-translate-y-1"
                style={{
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                  border: "1px solid rgba(255, 255, 255, 0.16)",
                }}
              >
                <p className="text-2xl font-bold m-0" style={{ color: "#66C7FF", textAlign: "left" }}>98%</p>
                <p className="text-sm m-0 mt-1" style={{ color: "#D9E4F2", textAlign: "left" }}>Client Retention</p>
              </div>
              <div
                className="p-4 rounded-lg transition-all duration-300 hover:-translate-y-1"
                style={{
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                  border: "1px solid rgba(255, 255, 255, 0.16)",
                }}
              >
                <p className="text-2xl font-bold m-0" style={{ color: "#F87171", textAlign: "left" }}>500+</p>
                <p className="text-sm m-0 mt-1" style={{ color: "#D9E4F2", textAlign: "left" }}>Hires Made</p>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div
              className="relative overflow-hidden rounded-lg"
              style={{
                border: "1px solid rgba(255, 255, 255, 0.18)",
                boxShadow: "0 28px 70px rgba(0, 0, 0, 0.34)",
              }}
            >
              <div className="absolute inset-0 z-10 bg-gradient-to-t from-[#001534]/30 via-transparent to-transparent"></div>
              <img
                src="https://ik.imagekit.io/7wqj9br0b/KapilTech_Website_Staffing/Home/Kapil%20Tech.jpg?updatedAt=1780547975797"
                alt="Kapil Tech recruitment team in modern office"
                className="w-full h-auto object-cover transition-all duration-700 hover:scale-[1.02]"
                loading="lazy"
                onError={(e) => {
                  e.currentTarget.src = "https://placehold.co/800x600/eef2f6/081120?text=IT+Recruitment+Team";
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
